<template>
  <div class="onboarding--container--bg">
    <div class="onboarding--container__desk">
      <div class="onboarding--header">
        <div class="prclx-logo">
          <asset-v3
            dir="logos"
            name="logo.svg"
          />
        </div>
      </div>

      <div class="onboarding--content">
        <asset-v3
          class="step--icon"
          dir="abstract"
          name="onboarding-desk.svg"
        />
        <h3 class="gray-900 mb-16">
          <span class="primary-500">
            Quase lá, {{ transaction.name | capitalize({ first: true }) }}.
          </span>
          <br>
          Falta pouco para concluir sua compra
        </h3>
        <p class="body-regular gray-900">
          No momento, estamos analisando as informações enviadas.
        </p>
        <p class="body-regular gray-900 mt-8">
          Você receberá uma notificação quando o processo for concluído.
        </p>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import StringMixing from '@/mixins/string';

export default {
  mixins: [StringMixing],
  name: 'v2-onboarding-selfie',
  components: {
    AssetV3,
  },
  computed: {
    ...mapState('onboardingV2', ['transaction']),
  },
  methods: {
    async handleVerifyCredit() {
      await this.$router.replace({
        name: 'v2-onboarding-desk' || this.nextRoute,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" style="scoped">
  @import '../../../scss/__new-styles.scss';

  .onboarding--container--bg {
    width: 100%;
    min-height: 100vh;

    @media (min-width: $breakpoint-large) {
      background-color: $gray-50;
      padding-top: 22px;
      padding-bottom: 1px;
    }
  }

  .onboarding--container__desk {
    background-color: $white;
    padding: 0px 24px 0 24px;
    display: grid;
    grid-template-rows: 76px 1fr 36px;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-height: 100vh;

    @media (min-width: $breakpoint-large) {
      margin: 0px auto 24px auto;
      max-width: 512px;
      border: 1px solid $gray-300;
      border-radius: 12px;
      box-shadow:
        0px 2px 4px -2px rgba(24, 39, 75, 0.12),
        0px 4px 4px -2px rgba(24, 39, 75, 0.08);
      min-height: auto;
    }
  }

  .onboarding--header {
    .prclx-logo {
      display: flex;
      padding-top: 16px;
      justify-content: center;
    }

    .step--bar {
      padding-top: 24px;
    }
  }

  .onboarding--content {
    .step--icon {
      margin-bottom: 12px;
    }
  }
</style>
